<template>	   
	<v-container>
	 	<v-card>
	 	 	<v-card-title primary-title>
	 	 		<h3 class="display-1">Datos Procesados</h3>
	 	 	</v-card-title>
	 	 	<v-card-text>
	 	 		<v-layout row wrap>
	 	 		  <v-flex xs8 pa-1>
			 	 		<v-text-field
			 	 		  name="search" solo v-model="table.search"
			 	 		  label="Buscar" append-icon="fa fa-search"
			 	 		  id="id"
			 	 		></v-text-field>
	 	 		  </v-flex>
	 	 		  <v-flex xs4 pa-1>
	 	 				<v-switch label="Ver subprocesos" v-model="subProccess"></v-switch>
	 	 		  </v-flex>
	 	 		</v-layout>
				<v-progress-linear :height="5" :active="table.loading" indeterminate></v-progress-linear>
	 	 	 	<v-data-table
	 	 	 	   :headers="table.headers"
	 	 	 	   :items="itemsComputed"
	 	 	 	   :search="table.search"
	 	 	 	   class="elevation-1" v-model="selected"
	 	 	 	   show-select
	 	 	 	   item-key="id"
	 	 	 	 >
	 	 	 	   	<template v-slot:items="props" >
	 	 	 	   		<tr :style="'color: '+ (props.item.sub_proccess == 0 ? 'black' : '#bababa') +';' ">
		 	 	 	   		<td>
	                <v-checkbox
	                  v-model="props.selected"
	                  primary hide-details/>
	              </td>
		 	 	 	   		<td>{{ props.item.id }}</td>
		 	 	 	   		<td>{{ props.item.name }}</td>
		 	 	 	   		<td>{{ props.item.frecuency }}</td>
		 	 	 	   		<td>{{ props.item.type }}</td>
		 	 	 	   		<td>
		 	 	 	   			<v-btn color="warning" small fab @click="edit(props.item)"><v-icon>fa fa-pen</v-icon></v-btn>
		 	 	 	   			<v-btn color="error" small fab @click="destroyConfirm(props.item)"><v-icon>fa fa-trash</v-icon></v-btn>
		 	 	 	   			<v-btn color="info" small fab @click="playProccess(props.item)"><v-icon>fa fa-play</v-icon></v-btn>
		 	 	 	   		</td>
	 	 	 	   		</tr>
	 	 	 	   	</template>
	 	 	 	   	<template v-slot:item.actions="{ item }">
	 	 	 	   		<td>
		 	 	 	   			<v-btn text color="warning" small fab @click="edit(item)"><v-icon>fa fa-pen</v-icon></v-btn>
		 	 	 	   			<v-btn text color="error" small fab @click="destroyConfirm(item)"><v-icon>fa fa-trash</v-icon></v-btn>
		 	 	 	   			<v-btn text color="info" small fab @click="playProccess(item)"><v-icon>fa fa-play</v-icon></v-btn>
		 	 	 	   		</td>
	 	 	 	   	</template>
	 	 	 	 </v-data-table> 
	 	 	</v-card-text>
	 	 	<v-card-actions>
	 	 	 	<v-btn color="success" @click="create()">Agregar nuevo Dato Procesado</v-btn> 
	 	 	</v-card-actions>
	 	</v-card>
	 	<v-dialog
	 	  v-model="modalDestroy.active"
	 	  scrollable  
	 	  :overlay="false"
	 	  max-width="500px"
	 	  transition="dialog-transition"
	 	>
	 	  <v-card>
	 	    <v-card-title primary-title>
	 	      <h3 class="display-1">¿Seguro que quiere borrar este procedimiento?</h3>
	 	    </v-card-title>
	 	    <v-card-text>
	 	    	<p>Esta a punto de borra el procedimiento: {{ modalDestroy.data.name }}. Al eliminarlo no podra recuperralo y se perderan todos los datos relacionados, para continuar con la eliminacion presione Aceptar para salir sin eliminar precione cancelar</p>
	 	      <v-btn color="info" @click="modalDestroy.active = false">Cancelar</v-btn>
	 	      <v-btn color="warning" @click="destroy()">Aceptar</v-btn>
	 	    </v-card-text>
	 	  </v-card>
	 	</v-dialog>
	 	<v-dialog
	 	  v-model="modalCreate.active"
	 	  scrollable 
	 	  :overlay="false" persistent
	 	  max-width="900px"
	 	  transition="dialog-transition"
	 	>
	 	  	<v-card>
	 	  	 	<v-card-title primary-title>
	 	  	 	  <h4 class="headline text-md-center">Crear nuevo Dato Procesado</h4>
	 	  	 	</v-card-title>
	 	  	 	<v-card-text>
	 	  			<Create @closemodal="closemodal" :dataParent="dataForm" />	 		 	 
	 	  	 	</v-card-text>
	 	  	 	<v-card-actions>
	 	  	 	</v-card-actions>
	 	  	</v-card>
	 	</v-dialog>
	 	<v-dialog
	 	  v-model="modalProccess.active"
	 	  scrollable  persistent
	 	  :overlay="false"
	 	  max-width="900px"
	 	  transition="dialog-transition"
	 	>
	 	  <v-card>
	 	    <v-card-title primary-title>
	 	      <h4 class="display-1">Ejecutar: {{modalProccess.data.name}}</h4>
	 	    </v-card-title>
	 	    <v-card-text>
	 	      <Proccess :dataParent="modalProccess.data" @closeModal="modalProccess.active = false" @serverDump="setAlert"/>
	 	    </v-card-text>
	 	  </v-card>
	 	</v-dialog>
	 	<v-snackbar
	 	  v-model="alert.active"
	 	>
	 	 {{ alert.message }}
	 	  <v-btn text :color="alert.color" @click.native="alert.active = false">Close</v-btn>
	 	</v-snackbar>
	</v-container>
</template>
<script>
import Create from './Create';
import Proccess from './Proccess';
	export default{
		components: {
			Create, Proccess
		},
		created() {

		},
		mounted(){
			this.getData();
		},
		props: [
			'auth'
		],
		data(){
			return {
				createCategory: '',
				subProccess: false,
				editCategory: '',
				baseRoute: process.env.VUE_APP_URL  + 'api/gis/',
				table: {
					items: [],
					headers: [],
					loading: true,
					search: ''
				},
				modalEdit: {
					active: false,
					data: {}
				},
				modalCreate: {
					active: false,
					data: {}
				},
				modalDestroy: {
					active: false,
					data: {}
				},
				alert: {
					active: false,
					message: "",
					color: "success"
				},
				dataForm: {
					name: '',
					frecuency: '',
					type: '',
					localities: [],
					layers: [],
					description: '',
				},
				modalProccess: {
					active: false,
					data: {}
				},
				selects: [],
				selected: [],
				response: ''
			}
		},
		methods: {
			setAlert(alert){
				this.alert = {
					active: true,
					color: 'error',
					message: alert
				}
			},
			closemodal(){
				this.getData();
				this.modalCreate.active = false;
			},
			playProccess(item){
				this.modalProccess.active = true;
				this.modalProccess.data = item;
			},
			getData(){
				axios.get(this.baseRoute + 'dataProccess/index').then((res) => {
					if(res.data == "Error"){
						this.alert.active = true;
						this.alert.message = "Impsoble traer los datos";
						this.alert.color = "error";
					}else{
						this.table.items = res.data.items;
						this.table.headers = res.data.headers;
						this.selects = res.data.selects;
					}
					this.table.loading = false;

				}).catch((error) => {
					this.table.loading = false;
					this.alert.active = true;
					this.alert.message = "Hubó un error interno en el servidor contacte con el desarrollador";
					this.alert.color = "error";
				});
			},
			create(){
				this.dataForm = {
					name: '',
					frecuency: '',
					type: '',
					localities: [],
					layers: [],
					description: '',
					edit: false,
				}
				this.modalCreate.active = true;
			},
			edit(item){
				this.dataForm = item;
				this.dataForm.edit = true;
				this.modalCreate.active = true;
			},
			actualiceData(){
				this.getData();
				this.modalCreate.active = false;
			},
			destroyConfirm(item){
				this.modalDestroy = {
					active: true,
					data: item
				}
			},
			destroy(){
				axios.post(this.baseRoute + 'dataProccess/destroy', this.modalDestroy.data).then((res) => {
					if(res.data == "Exito"){
						this.modalDestroy.active = false;
						this.modalDestroy.data = {};

						this.alert = {
							active: true,
							message: "Elemento eliminado correctamente",
							color: "success"
						}
						this.getData()
					}else{
						this.alert = {
							active: true,
							message: "Hubó un problema al realizar la accion intente nuevamente",
							color: "error"
						}
					}
				}).catch((error) => {
					this.alert = {
							active: true,
							message: "Hubó un problema al realizar la accion intente nuevamente",
							color: "error"
						}
				})
			}

		},
		watch: {

		},
		computed: {
			itemsComputed: function(){
				if(!this.subProccess){
					return this.table.items.filter(function(item){
						return !item.sub_proccess
					})
				}else{
					return this.table.items
				}
			}
		},
	}
</script>